module.exports = __webpack_public_path__ + "static/media/regisInputPhone.a94412d4.svg";